import { render, staticRenderFns } from "./wl_award.vue?vue&type=template&id=08af677c&scoped=true"
import script from "./wl_award.vue?vue&type=script&lang=js"
export * from "./wl_award.vue?vue&type=script&lang=js"
import style0 from "./wl_award.vue?vue&type=style&index=0&id=08af677c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08af677c",
  null
  
)

export default component.exports